
import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { type EnhancedCrawlResult } from '@/types/crawler';

interface BasicStatsProps {
  crawlResult: EnhancedCrawlResult;
}

const BasicStats: React.FC<BasicStatsProps> = ({ crawlResult }) => {
  // Format the duration to show minutes and seconds
  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.round(seconds % 60);
    return `${minutes}m ${remainingSeconds}s`;
  };

  return (
    <div className="space-y-4 mb-6">
      <div className="flex justify-between items-center">
        <span className="text-base">Robots.txt found:</span>
        <span className="text-base font-medium flex items-center">
          {crawlResult.robotsTxt ? (
            <>
              <CheckCircle className="w-4 h-4 mr-1 text-green-500" />
              Yes
            </>
          ) : (
            <>
              <XCircle className="w-4 h-4 mr-1 text-red-500" />
              No
            </>
          )}
        </span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-base">Crawl duration:</span>
        <span className="text-base font-medium">
          {formatDuration(crawlResult.duration)}
        </span>
      </div>
    </div>
  );
};

export default BasicStats;
